<script>
import api from '@utils/api'

export default {
  name: 'UserNew',
  props: {
    newUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      newItem: {
        login: null,
        email: null,
        firstName: null,
        lastName: null,
        tel: null,
        description: null,
        roles: null,
        status: 1,
      },
      rules: {
        login: [x => !!x || this.$t('validation__is_required')],
        email: [
          x =>
            (!!x &&
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(x)) ||
            this.$t('invalid_email'),
        ],
        firstName: [x => !!x || this.$t('validation__is_required')],
        lastName: [x => !!x || this.$t('validation__is_required')],
        roles: [
          x => (!!x && x.length > 0) || this.$t('validation__is_required'),
        ],
      },
    }
  },
  computed: {
    status() {
      return this.$store.getters['data/getDictionary']('userstatus').map(item => {
        item.translatedName = this.$t(`userstatus.${item.code}.name`)
        return item
      })
    },
    rolesDict() {
      const roles = this.$store.getters['data/getDictionary']('role')
      return roles.filter(
        item =>
          item.code === 'SUPERUSER' ||
          item.code === 'GUEST' ||
          item.code === 'DICTIONARIES_OPERATOR' ||
          item.code === 'DOCUMENTS_OPERATOR' ||
          item.code === 'REPORTS_OPERATOR' ||
          item.code === 'EVENTS_OPERATOR'
      ).map(item => {
        item.translatedName = this.$t(item.i18nKeyName);
        return item
      })
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
      this.$refs.newUserForm.reset()
      this.newItem.status = 1
    },
    submit() {
      if (this.$refs.newUserForm.validate()) {
        this.loading = true
        api.createUser(this.newItem).then(response => {
          if (response) {
            this.$store.dispatch('data/updateDictionary', 'user')
            this.$router.push(`users/${response.user.id}`)
            this.$store.commit('notifications/ADD', {
              type: response.error ? 'warning': 'success',
              message: `${response.error ? this.$t('message__couldnt_send_email') : this.$t('message__verification_link_sent')} ${
                  this.newItem.email
              }`,
            })
          }
          this.loading = false
        })
      }
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="newUser"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__new_user') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-form
                ref="newUserForm"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                  :label="$t('label__user_name')"
                  v-model="newItem.login"
                  :rules="rules.login"
                  name="login"
                  autocomplete="off"
                  required
                />
                <v-text-field
                  :label="$t('label__email')"
                  v-model="newItem.email"
                  :rules="rules.email"
                  type="email"
                  name="email"
                  autocomplete="off"
                  required
                />
                <v-text-field
                  :label="$t('label__first_name')"
                  v-model="newItem.firstName"
                  :rules="rules.firstName"
                  name="firstname"
                  autocomplete="off"
                  required
                />
                <v-text-field
                  :label="$t('label__last_name')"
                  v-model="newItem.lastName"
                  :rules="rules.lastName"
                  name="lastname"
                  required
                  autocomplete="off"
                />
                <v-text-field
                  :label="$t('label__phone')"
                  v-model="newItem.tel"
                  :rules="rules.tel"
                  name="tel"
                  autocomplete="off"
                />
                <v-text-field
                  :label="$t('label__description')"
                  v-model="newItem.description"
                  name="description"
                  autocomplete="off"
                />
                <v-select
                  :items="rolesDict"
                  :label="$t('label__roles')"
                  :rules="rules.roles"
                  v-model="newItem.roles"
                  item-text="translatedName"
                  item-value="code"
                  autocomplete
                  multiple
                  clearable
                  required
                />
                <v-select
                  :items="status"
                  :label="$t('label__status')"
                  :rules="rules.status"
                  v-model="newItem.status"
                  item-text="translatedName"
                  item-value="code"
                  required
                  autocomplete
                />
              </v-form>
            </v-flex>
            <small>* {{ $t('label__requier_small_text') }}</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="closeModal">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="primary"
          @click="submit">{{ $t('buttons__create') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
